<template>
  <div class="care-plan-hub">
    <div class="hub-header">
      <h2>{{ hub.title }}</h2>
      <p>{{ hub.description }}</p>
    </div>
    <el-row :gutter="16" class="hub-grid">
      <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="item in hub.children" :key="item.path">
        <el-card shadow="hover" class="hub-card" @click.native="go(item)">
          <div class="card-icon"><i :class="item.icon"></i></div>
          <div class="card-title">{{ item.title }}</div>
          <div class="card-desc">{{ item.desc }}</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus";
import { CARE_PLAN_HUBS, CARE_PLAN_HUB_PATH_TO_KEY } from "./carePlanHubConfig";

export default {
  name: "CarePlanModuleHub",
  computed: {
    hubKey() {
      const m = this.$route.meta && this.$route.meta.hubKey;
      if (m) return m;
      const matched = this.$route.matched;
      if (matched && matched.length) {
        const last = matched[matched.length - 1];
        if (last.meta && last.meta.hubKey) return last.meta.hubKey;
      }
      return CARE_PLAN_HUB_PATH_TO_KEY[this.$route.path] || "";
    },
    hub() {
      return CARE_PLAN_HUBS[this.hubKey] || { title: "护理计划", description: "", children: [] };
    }
  },
  methods: {
    go(item) {
      bus.$emit("homePage", { type: "jump", path: item.path, title: item.title });
    }
  }
};
</script>
<style lang="scss" scoped>
.care-plan-hub {
  padding: 20px 24px;
  background: #fefefe;
  min-height: 400px;
}
.hub-header h2 {
  font-size: 18px;
  color: #303133;
  margin: 0 0 8px;
}
.hub-header p {
  color: #909399;
  font-size: 14px;
  margin: 0 0 20px;
  line-height: 1.6;
}
.hub-card {
  margin-bottom: 16px;
  cursor: pointer;
  text-align: center;
  transition: transform 0.15s;
}
.hub-card:hover {
  transform: translateY(-2px);
}
.card-icon {
  font-size: 28px;
  color: #1395db;
  margin-bottom: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}
.card-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  min-height: 36px;
}
</style>
